import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-07e4df2f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrap" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "createTime" }
const _hoisted_4 = { class: "box mark" }
const _hoisted_5 = {
  key: 0,
  style: {"color":"red","padding":"12px","background":"rgb(229, 246, 244)","font-weight":"600"}
}
const _hoisted_6 = { class: "high-light" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "space" }, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"color":"red","padding":"10px 10px 0 10px","font-size":"14px"} }, " ⚠️⚠️⚠️ 点击排行榜中某一片区名称，下方会联动展示该区域下对应的所有厅台毛利排行榜 ", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ranking" }, "片区毛利排行榜", -1))
const _hoisted_11 = {
  key: 1,
  class: "mark"
}
const _hoisted_12 = ["onClick"]
const _hoisted_13 = {
  class: "row",
  style: {
                    background: '#E5F6F4',
                    fontWeight: 600,
                    padding: '10px',
                    fontSize: '16px',
                    lineHeight: '20px',
                  }
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { style: {"color":"blue","font-weight":"400","font-size":"14px","padding-left":"5px"} }, "点击此处联动下方", -1))
const _hoisted_15 = { class: "grap" }
const _hoisted_16 = { style: {"position":"relative"} }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_18 = { style: {"position":"relative"} }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ranking" }, "营业厅毛利排行榜", -1))
const _hoisted_22 = {
  key: 3,
  class: "mark"
}
const _hoisted_23 = {
  class: "row",
  style: {
                    background: '#E5F6F4',
                    fontWeight: 600,
                    padding: '10px',
                    fontSize: '14px',
                  }
}
const _hoisted_24 = { class: "grap" }
const _hoisted_25 = { style: {"position":"relative"} }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_27 = { style: {"position":"relative"} }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"color":"red","padding":"10px 10px 0 10px","font-size":"14px"} }, " ⚠️⚠️⚠️ 点击排行榜中某一分公司名称，下方会联动展示该分公司下对应的所有厅台毛利排行榜 ", -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ranking" }, "分公司毛利排行榜", -1))
const _hoisted_32 = {
  key: 1,
  class: "mark"
}
const _hoisted_33 = ["onClick"]
const _hoisted_34 = {
  class: "row",
  style: {
                    background: '#E5F6F4',
                    fontWeight: 600,
                    padding: '10px',
                    fontSize: '16px',
                    lineHeight: '20px',
                  }
}
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { style: {"color":"blue","font-weight":"400","font-size":"14px","padding-left":"5px"} }, "点击此处联动下方", -1))
const _hoisted_36 = { class: "grap" }
const _hoisted_37 = { style: {"position":"relative"} }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_39 = { style: {"position":"relative"} }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ranking" }, "营业厅毛利排行榜", -1))
const _hoisted_43 = {
  key: 3,
  class: "mark"
}
const _hoisted_44 = {
  class: "row",
  style: {
                    background: '#E5F6F4',
                    fontWeight: 600,
                    padding: '10px',
                    fontSize: '14px',
                  }
}
const _hoisted_45 = { class: "grap" }
const _hoisted_46 = { style: {"position":"relative"} }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_48 = { style: {"position":"relative"} }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ranking" }, "店员销售排行TOP30", -1))
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "row mark",
  style: { background: '#E5F6F4', fontWeight: 500 }
}, [
  /*#__PURE__*/_createElementVNode("div", { style: {
                  width: '100px',
                  flexGrow: 0,
                } }, " 销售姓名 "),
  /*#__PURE__*/_createElementVNode("div", { style: {
                  width: '100px',
                  flexGrow: 2,
                } }, " 所属厅台 "),
  /*#__PURE__*/_createElementVNode("div", { class: "percentage" }, "月累计毛利"),
  /*#__PURE__*/_createElementVNode("div", { class: "percentage" }, "日毛利")
], -1))
const _hoisted_53 = { class: "mark" }
const _hoisted_54 = { style: {
                    width: '100px',
                    flexGrow: 0,
                  } }
const _hoisted_55 = { style: {
                    width: '100px',
                    flexGrow: 2,
                  } }

import { ref, watch, onMounted, nextTick } from "vue";
import { useRoute } from "vue-router";
import { CellGroup, Cell, Tabs, Tab, Overlay, Loading, Empty } from "vant";
import { formatPercentage, numToMoney } from "@/utils";
import createWatermark from "@/utils/watermark";
import dayjs from "dayjs";

import request from "@/provide/fetch";


export default /*#__PURE__*/_defineComponent({
  __name: 'BusinessHallBJMbdc',
  setup(__props) {

const route = useRoute();
const active = ref(0);
const productOrderPayCountAsc = ref(false); // 产品-下单成功量升序

const visible = ref(false);
const pageData = ref<any>({});
let time = dayjs(route?.params.time as string).format("YYYY-MM-DD");
const getPageData = async () => {
  const res = await request({
    url: "/api/wx/bh/target-achievement-summary",
    method: "POST",
    data: {
      startDay: time,
      endDay: time,
      provinceName: "北京",
    },
    headers: {
      openId: sessionStorage.getItem("openid"),
    },
  });
  if (res.code === 200) {
    // showSuccessToast("保存成功！");
    pageData.value = res.data;
    visible.value = true;
    console.log(pageData.value);
  } else {
    // showFailToast(res.data);
  }
};
getPageData();

// 区域排行
const areaList = ref<any>([]);
const getProductsData = async () => {
  const res = await request({
    url: "/api/wx/bh/area-businessHall-target-top",
    method: "POST",
    data: {
      startDay: time,
      endDay: time,
      groupUnit: "area",
      province: "北京",
    },
    headers: {
      openId: sessionStorage.getItem("openid"),
    },
    // params: {
    //   openId: 'o7Gwj6b4bHVGwrEVKckufk8jjIh4',
    // },
  });
  if (res.code === 200) {
    // showSuccessToast("保存成功！");
    areaList.value = res.data.map((item) => {
      return {
        ...item,
        drelativeRatioFlag: item.drelativeRatio.indexOf("-") !== -1,
        mrelativeRatioFlag: item.mrelativeRatio.indexOf("-") !== -1,
      };
    });
    if (res.data?.[0]?.areaBusinessHallName) {
      handleClick(res.data[0].areaBusinessHallName, 0);
    }
  } else {
    // showFailToast(res.data);
  }
};
getProductsData();

// 选择区域
const selectedArea = ref("");
const businessHallList = ref<any[]>([]);
const handleClick = async (area: any, index: number) => {
  const res = await request({
    url: "/api/wx/bh/area-businessHall-target-top",
    method: "POST",
    data: {
      startDay: time,
      endDay: time,
      groupUnit: "businessHall",
      province: "北京",
      area: area,
      manager: "",
    },
    headers: {
      openId: sessionStorage.getItem("openid"),
    },
    // params: {
    //   openId: 'o7Gwj6b4bHVGwrEVKckufk8jjIh4',
    // },
  });
  if (res.code === 200) {
    // showSuccessToast("保存成功！");
    businessHallList.value = res.data.map((item: any) => {
      return {
        ...item,
        drelativeRatioFlag: item.drelativeRatio.indexOf("-") !== -1,
        mrelativeRatioFlag: item.mrelativeRatio.indexOf("-") !== -1,
      };
    });
  } else {
    // showFailToast(res.data);
  }
};
// handleClick();
// 片区维度
const SliceDimension = ref<any>([]);
const getSliceDimensionData = async () => {
  const res = await request({
    url: "/api/wx/bh/area-businessHall-target-top",
    method: "POST",
    data: {
      startDay: time,
      endDay: time,
      groupUnit: "manager",
      province: "北京",
    },
    headers: {
      openId: sessionStorage.getItem("openid"),
    },
    // params: {
    //   openId: 'o7Gwj6b4bHVGwrEVKckufk8jjIh4',
    // },
  });
  if (res.code === 200) {
    // showSuccessToast("保存成功！");
    SliceDimension.value = res.data.map((item) => {
      return {
        ...item,
        drelativeRatioFlag: item.drelativeRatio.indexOf("-") !== -1,
        mrelativeRatioFlag: item.mrelativeRatio.indexOf("-") !== -1,
      };
    });
    if (res.data?.[0]?.areaBusinessHallName) {
      getmanagerBusinessHallList(res.data[0].areaBusinessHallName, 0);
    }
  } else {
    // showFailToast(res.data);
  }
};
getSliceDimensionData();
const managerBusinessHallList = ref<any[]>([]);
const managerActiveItem = ref(0);
const getmanagerBusinessHallList = async (manager: any, index: any) => {
  managerActiveItem.value = index;
  const res = await request({
    url: "/api/wx/bh/area-businessHall-target-top",
    method: "POST",
    data: {
      startDay: time,
      endDay: time,
      groupUnit: "businessHall",
      province: "北京",
      manager: manager,
      area: "",
    },
    headers: {
      openId: sessionStorage.getItem("openid"),
    },
  });
  if (res.code === 200) {
    // showSuccessToast("保存成功！");
    managerBusinessHallList.value = res.data.map((item) => {
      return {
        ...item,
        drelativeRatioFlag: item.drelativeRatio.indexOf("-") !== -1,
        mrelativeRatioFlag: item.mrelativeRatio.indexOf("-") !== -1,
      };
    });
    // if (res.data?.[0]?.area) {
  }
};
// getmanagerBusinessHallList()
// 店员排行
const distributorLoading = ref(false);
const sellerList = ref<any>([]);
const getSellerList = async () => {
  distributorLoading.value = true;
  const res = await request({
    url: "/api/wx/bh/hall-target-sale-person/detail",
    method: "GET",
    params: {
      startDay: time,
      endDay: time,
      // pageParam: {
      //   current: 1,
      //   size: 30,
      // },
      // searchOption: {
      //   startDay: time,
      //   endDay: time,
      //   statisticColumn: "salesMan",
      //   orderItem: {
      //     field: "grossProfit",
      //     asc: false,
      //   },
      //   salePerson: true,
      //   province: "北京",
      //   // groupUnit: sessionStorage.getItem("openid"),
      // },
    },
    headers: {
      openId: sessionStorage.getItem("openid"),
    },
  });
  distributorLoading.value = false;
  if (res.code === 200) {
    // showSuccessToast("保存成功！");
    sellerList.value = res.data;
  } else {
    // showFailToast(res.data);
  }
};
getSellerList();

watch(productOrderPayCountAsc, () => {
  getProductsData();
});

const getUserInfo = async () => {
  return request({
    url: "/api/wx/user/getUserByOpenId",
    method: "GET",
    params: {
      openId: sessionStorage.getItem("openid"),
    },
  }).then((res) => {
    if (res.code === 200) {
      sessionStorage.setItem("name", res.data.name);
    }
  });
};
const activeItem = ref(0);
onMounted(() => {
  if (sessionStorage.getItem("name")) {
    createWatermark(sessionStorage.getItem("name"), "mark", "#fff");
  } else {
    getUserInfo().then(() => {
      createWatermark(sessionStorage.getItem("name"), "mark", "#fff");
    });
  }
});

const tabs = ref();
watch(visible, () => {
  nextTick(() => {
    tabs.value.resize();
  });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", null, "生成时间： " + _toDisplayString(_unref(dayjs)(_unref(route).params.time as string).format("YYYY-MM-DD")), 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pageData.value, (item, key, index) => {
          return (_openBlock(), _createBlock(_unref(CellGroup), { key: index }, {
            default: _withCtx(() => [
              key
                ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(key), 1))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item, (childRenItem, childRenIndex) => {
                return (_openBlock(), _createBlock(_unref(Cell), {
                  title: childRenItem.name,
                  size: "large",
                  class: "bold",
                  "title-style": { width: '120px', flex: 'inherit' },
                  key: childRenIndex
                }, {
                  value: _withCtx(() => [
                    _createElementVNode("span", _hoisted_6, [
                      _createTextVNode(_toDisplayString(childRenItem.type === "percentage"
                    ? _unref(formatPercentage)(childRenItem.value)
                    : childRenItem.value) + " ", 1),
                      (
                    childRenItem.name !== '月目标毛利' &&
                    childRenItem.name !== '月累积达成率'
                  )
                        ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                            _createTextVNode("（" + _toDisplayString(childRenItem.name == "月实毛利" ||
                    childRenItem.name == "月累积毛利"
                      ? "月环比"
                      : "环比") + "：", 1),
                            _createElementVNode("span", {
                              style: _normalizeStyle({
                      color: childRenItem.percentage >= 0 ? 'green' : 'red',
                    })
                            }, _toDisplayString(`${
                        childRenItem.percentage >= 0 ? "+" : ""
                      }${_unref(formatPercentage)(childRenItem.percentage)}`), 5),
                            _createTextVNode("）")
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 2
                }, 1032, ["title"]))
              }), 128))
            ]),
            _: 2
          }, 1024))
        }), 128)),
        _hoisted_8,
        _createVNode(_unref(Tabs), {
          active: active.value,
          "onUpdate:active": _cache[0] || (_cache[0] = ($event: any) => ((active).value = $event)),
          ref_key: "tabs",
          ref: tabs
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(Tab), { title: "片区维度" }, {
              default: _withCtx(() => [
                _hoisted_9,
                _hoisted_10,
                (!SliceDimension.value.length)
                  ? (_openBlock(), _createBlock(_unref(Empty), {
                      key: 0,
                      description: "暂无数据",
                      "image-size": "100"
                    }))
                  : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(SliceDimension.value, (item, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          style: { borderBottom: '1px solid #ebedf0' },
                          key: index,
                          onClick: ($event: any) => (
                  getmanagerBusinessHallList(item.areaBusinessHallName, index)
                ),
                          class: _normalizeClass({ active: managerActiveItem.value === index })
                        }, [
                          _createElementVNode("div", _hoisted_13, [
                            _createElementVNode("span", {
                              class: _normalizeClass({
                      one: index == 0,
                      two: index == 1,
                      three: index == 2,
                      other: index > 2,
                    })
                            }, _toDisplayString(index + 1), 3),
                            _createTextVNode(" " + _toDisplayString(item.areaBusinessHallName) + " ", 1),
                            _hoisted_14
                          ]),
                          _createElementVNode("div", _hoisted_15, [
                            _createElementVNode("div", null, " 月目标毛利: " + _toDisplayString(_unref(numToMoney)(item.mtargetGrossMargin)), 1),
                            _createElementVNode("div", _hoisted_16, [
                              _createTextVNode(" 日毛利收入: " + _toDisplayString(_unref(numToMoney)(item.grossProfit)) + " ", 1),
                              _hoisted_17,
                              _createElementVNode("div", {
                                class: _normalizeClass({
                        minus: !item.drelativeRatioFlag,
                        positive: item.drelativeRatioFlag,
                      })
                              }, " (日环比: " + _toDisplayString(item.drelativeRatio) + ") ", 3)
                            ]),
                            _createElementVNode("div", _hoisted_18, [
                              _createTextVNode(" 月累积毛利: " + _toDisplayString(_unref(numToMoney)(item.maccumulateGrossMargin)) + " ", 1),
                              _hoisted_19,
                              _createElementVNode("div", {
                                class: _normalizeClass({
                        minus: !item.mrelativeRatioFlag,
                        positive: item.mrelativeRatioFlag,
                      })
                              }, " (月环比: " + _toDisplayString(item.mrelativeRatio) + ") ", 3)
                            ]),
                            _hoisted_20,
                            _createElementVNode("div", null, "月累积达成率: " + _toDisplayString(item.machievementRate), 1)
                          ])
                        ], 10, _hoisted_12))
                      }), 128))
                    ])),
                _hoisted_21,
                (!managerBusinessHallList.value.length)
                  ? (_openBlock(), _createBlock(_unref(Empty), {
                      key: 2,
                      description: "暂无数据",
                      "image-size": "100"
                    }))
                  : (_openBlock(), _createElementBlock("div", _hoisted_22, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(managerBusinessHallList.value, (item, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          style: { borderBottom: '1px solid #ebedf0' },
                          key: index
                        }, [
                          _createElementVNode("div", _hoisted_23, [
                            _createElementVNode("span", {
                              class: _normalizeClass({
                      one: index == 0,
                      two: index == 1,
                      three: index == 2,
                      other: index > 2,
                    })
                            }, _toDisplayString(index + 1), 3),
                            _createTextVNode(" " + _toDisplayString(item.areaBusinessHallName), 1)
                          ]),
                          _createElementVNode("div", _hoisted_24, [
                            _createElementVNode("div", null, " 月目标毛利: " + _toDisplayString(_unref(numToMoney)(item.mtargetGrossMargin)), 1),
                            _createElementVNode("div", _hoisted_25, [
                              _createTextVNode(" 日毛利收入: " + _toDisplayString(_unref(numToMoney)(item.grossProfit)) + " ", 1),
                              _hoisted_26,
                              _createElementVNode("div", {
                                class: _normalizeClass({
                        minus: !item.drelativeRatioFlag,
                        positive: item.drelativeRatioFlag,
                      })
                              }, " (日环比: " + _toDisplayString(item.drelativeRatio) + ") ", 3)
                            ]),
                            _createElementVNode("div", _hoisted_27, [
                              _createTextVNode(" 月累积毛利: " + _toDisplayString(_unref(numToMoney)(item.maccumulateGrossMargin)) + " ", 1),
                              _hoisted_28,
                              _createElementVNode("div", {
                                class: _normalizeClass({
                        minus: !item.mrelativeRatioFlag,
                        positive: item.mrelativeRatioFlag,
                      })
                              }, " (月环比: " + _toDisplayString(item.mrelativeRatio) + ") ", 3)
                            ]),
                            _hoisted_29,
                            _createElementVNode("div", null, "月累积达成率: " + _toDisplayString(item.machievementRate), 1)
                          ])
                        ]))
                      }), 128))
                    ]))
              ]),
              _: 1
            }),
            _createVNode(_unref(Tab), { title: "分公司维度" }, {
              default: _withCtx(() => [
                _hoisted_30,
                _hoisted_31,
                (!areaList.value.length)
                  ? (_openBlock(), _createBlock(_unref(Empty), {
                      key: 0,
                      description: "暂无数据",
                      "image-size": "100"
                    }))
                  : (_openBlock(), _createElementBlock("div", _hoisted_32, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(areaList.value, (item, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          onClick: ($event: any) => (handleClick(item.areaBusinessHallName, index)),
                          style: { borderBottom: '1px solid #ebedf0' },
                          key: index
                        }, [
                          _createElementVNode("div", _hoisted_34, [
                            _createElementVNode("span", {
                              class: _normalizeClass({
                      one: index == 0,
                      two: index == 1,
                      three: index == 2,
                      other: index > 2,
                    })
                            }, _toDisplayString(index + 1), 3),
                            _createTextVNode(" " + _toDisplayString(item.areaBusinessHallName) + " ", 1),
                            _hoisted_35
                          ]),
                          _createElementVNode("div", _hoisted_36, [
                            _createElementVNode("div", null, " 月目标毛利: " + _toDisplayString(_unref(numToMoney)(item.mtargetGrossMargin)), 1),
                            _createElementVNode("div", _hoisted_37, [
                              _createTextVNode(" 日毛利收入: " + _toDisplayString(_unref(numToMoney)(item.grossProfit)) + " ", 1),
                              _hoisted_38,
                              _createElementVNode("div", {
                                class: _normalizeClass({
                        minus: !item.drelativeRatioFlag,
                        positive: item.drelativeRatioFlag,
                      })
                              }, " (日环比: " + _toDisplayString(item.drelativeRatio) + ") ", 3)
                            ]),
                            _createElementVNode("div", _hoisted_39, [
                              _createTextVNode(" 月累积毛利: " + _toDisplayString(_unref(numToMoney)(item.maccumulateGrossMargin)) + " ", 1),
                              _hoisted_40,
                              _createElementVNode("div", {
                                class: _normalizeClass({
                        minus: !item.mrelativeRatioFlag,
                        positive: item.mrelativeRatioFlag,
                      })
                              }, " (月环比: " + _toDisplayString(item.mrelativeRatio) + ") ", 3)
                            ]),
                            _hoisted_41,
                            _createElementVNode("div", null, "月累积达成率: " + _toDisplayString(item.machievementRate), 1)
                          ])
                        ], 8, _hoisted_33))
                      }), 128))
                    ])),
                _hoisted_42,
                (!businessHallList.value.length)
                  ? (_openBlock(), _createBlock(_unref(Empty), {
                      key: 2,
                      description: "暂无数据",
                      "image-size": "100"
                    }))
                  : (_openBlock(), _createElementBlock("div", _hoisted_43, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(businessHallList.value, (item, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          style: { borderBottom: '1px solid #ebedf0' },
                          key: index
                        }, [
                          _createElementVNode("div", _hoisted_44, [
                            _createElementVNode("span", {
                              class: _normalizeClass({
                      one: index == 0,
                      two: index == 1,
                      three: index == 2,
                      other: index > 2,
                    })
                            }, _toDisplayString(index + 1), 3),
                            _createTextVNode(" " + _toDisplayString(item.areaBusinessHallName), 1)
                          ]),
                          _createElementVNode("div", _hoisted_45, [
                            _createElementVNode("div", null, " 月目标毛利: " + _toDisplayString(_unref(numToMoney)(item.mtargetGrossMargin)), 1),
                            _createElementVNode("div", _hoisted_46, [
                              _createTextVNode(" 日毛利收入: " + _toDisplayString(_unref(numToMoney)(item.grossProfit)) + " ", 1),
                              _hoisted_47,
                              _createElementVNode("div", {
                                class: _normalizeClass({
                        minus: !item.drelativeRatioFlag,
                        positive: item.drelativeRatioFlag,
                      })
                              }, " (日环比: " + _toDisplayString(item.drelativeRatio) + ") ", 3)
                            ]),
                            _createElementVNode("div", _hoisted_48, [
                              _createTextVNode(" 月累积毛利: " + _toDisplayString(_unref(numToMoney)(item.maccumulateGrossMargin)) + " ", 1),
                              _hoisted_49,
                              _createElementVNode("div", {
                                class: _normalizeClass({
                        minus: !item.mrelativeRatioFlag,
                        positive: item.mrelativeRatioFlag,
                      })
                              }, " (月环比: " + _toDisplayString(item.mrelativeRatio) + ") ", 3)
                            ]),
                            _hoisted_50,
                            _createElementVNode("div", null, "月累积达成率: " + _toDisplayString(item.machievementRate), 1)
                          ])
                        ]))
                      }), 128))
                    ]))
              ]),
              _: 1
            }),
            _createVNode(_unref(Tab), { title: "店员维度" }, {
              default: _withCtx(() => [
                _hoisted_51,
                _hoisted_52,
                (!sellerList.value.length)
                  ? (_openBlock(), _createBlock(_unref(Empty), {
                      key: 0,
                      description: "暂无数据",
                      "image-size": "100"
                    }))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_53, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sellerList.value, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "row",
                      key: index
                    }, [
                      _createElementVNode("div", _hoisted_54, _toDisplayString(item.employee), 1),
                      _createElementVNode("div", _hoisted_55, _toDisplayString(item.businessHallName), 1),
                      _createElementVNode("div", null, _toDisplayString(_unref(numToMoney)(item.monthGrossProfit)), 1),
                      _createElementVNode("div", null, _toDisplayString(_unref(numToMoney)(item.dayGrossProfit)), 1)
                    ]))
                  }), 128))
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["active"])
      ])
    ], 512), [
      [_vShow, visible.value]
    ]),
    _createVNode(_unref(Overlay), {
      class: "overlay",
      show: !visible.value
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Loading), { type: "spinner" })
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}
}

})